export const QA_SUPPOSED_RATING = [
  'RUW',
  'Decline',
  'Preferred Plus',
  'Preferred / Tobacco',
  'Preferred / Non Tobacco',
  'Standard Plus / Tobacco',
  'Standard Plus / Non Tobacco',
  'Standard / Tobacco',
  'Standard / Non Tobacco',
  'Standard 25 / Tobacco',
  'Standard 25 / Non Tobacco',
  'Standard 50 / Tobacco',
  'Standard 50 / Non Tobacco',
  'Standard 75 / Tobacco',
  'Standard 75 / Non Tobacco',
  'Standard 100 / Tobacco',
  'Standard 100 / Non Tobacco',
  'Standard 125 / Tobacco',
  'Standard 125 / Non Tobacco',
  'Standard 150 / Tobacco',
  'Standard 150 / Non Tobacco',
  'Standard 175 / Tobacco',
  'Standard 175 / Non Tobacco',
  'Standard 200 / Tobacco',
  'Standard 200 / Non Tobacco',
  'Standard 225 / Tobacco',
  'Standard 225 / Non Tobacco',
  'Standard 250 / Tobacco',
  'Standard 250 / Non Tobacco',
];
